<div class="card" *ngIf="isZapierEnabled">
    <div class="card-body">
        <h4 class="card-title">Automate Sending Review Requests with Zapier</h4>

        <ol>
            <li>
                <a target="_blank" href="https://zapier.com/apps">
                    Use the search box found on this page on Zapier’s website
                </a>
                to see if the application you use is compatible Zapier
            </li>

            <li>
                If you don’t already have a Zapier account,
                <a target="_blank" href="https://zapier.com/platform/sign-up">
                    create a free one by clicking here
                </a>
            </li>

            <li>
                Gain access to our Zapier app by
                <a target="_blank" href="https://zapier.com/developer/public-invite/94891/3146220e7e6eb47f52c3e298e776c925/">
                    clicking this link and then clicking the ”Accept Invite and Build a Zap” button found on the page
                </a>
            </li>

            <li>
                To book an automation setup call with us, and for more information
                <a target="_blank" href="https://help.getmorereviews.com/en/collections/2382256-review-request-automation">
                    click here to visit our “Zapier Integration Guide”
                </a>
            </li>

            <li>
                Copy the API Token below into Zapier when prompted as part of creating a Zap:
            </li>

            <div class="position-relative form-group" (click)="copyToClipboard()">
                <input type="text" class="form-control txt-input"
                    readonly
                    [(ngModel)]="zapierKey"
                />

                <div class="txt-input-copy-icon" style="cursor: pointer"></div>
            </div>
        </ol>
    </div>
</div>
